export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";